import React, { useState, useEffect } from 'react';
import { BsSearch } from 'react-icons/bs';
import settings from '../../data/settings';

const SearchInput = (props) => {
  const [isSearchbarVisible, setIsSearchbarVisible] = useState(
    settings.searchbar_visibility
  );
  const [searchLabelText, setSearchLabelText] = useState(
    settings.search_label_text
  );

  const [searchBarColor, setSearchBarColor] = useState('#fff');

  const searchBarStyle = {
    backgroundColor: searchBarColor,
  };

  useEffect(() => {
    setIsSearchbarVisible(settings.searchbar_visibility);
    setSearchLabelText(settings.search_label_text);
  }, [isSearchbarVisible]);

  useEffect(() => {
    setSearchBarColor(settings.colors.navigation_background_color);
  }, []);

  return (
    <div
      style={{
        display: `${isSearchbarVisible ? 'block' : 'none'}`,
        backgroundColor: searchBarColor,
      }}
    >
      <div className='w-full flex flex-row justify-between viergrad-custom-menu-font-regular pt-2.5'>
        <input
          className='border-0 outline-0 w-full viergrad-custom-menu-font-regular'
          placeholder={searchLabelText}
          bordered='false'
          onChange={props.onChange}
          onKeyDown={props.onKeyDown}
          style={searchBarStyle}
        />
        <div className='pr-1.5 hover:cursor-pointer' onClick={props.onClick}>
          <BsSearch color='#969696' />
        </div>
      </div>
      <hr />
    </div>
  );
};

export default SearchInput;
